export function MarketplaceListingPanel() {
  return (
    <div className="space-y-2">
      <p className="text-sm font-semibold">Marketplace Listing</p>
      <p className="text-sm text-muted-foreground">Coming soon.</p>
    </div>
  )
}
